import styles from './Admin.module.css';

/**
 * Plan → CSS-module-class name. Shared by every admin table that
 * renders a plan badge (Accounts · Usage · Overrides · Cancellations)
 * so the four pages can't drift on which background color goes with
 * which tier.
 *
 * Returns `string | undefined` to match the CSS-modules typing —
 * Admin.module.css doesn't ship a `.d.ts` that proves every key is
 * present at runtime, so consumers should pass the result through
 * `cn()` which tolerates `undefined` gracefully.
 */
export type Plan = 'free' | 'personal' | 'team' | 'business' | 'enterprise';

/**
 * Accepts `string` (not just the narrow Plan union) so cancellation
 * rows — which carry the plan at cancel time, possibly a historical
 * value we don't have in our current union — can still render a
 * badge. Unknown plans fall back to the free-tier styling so the
 * column never breaks layout.
 */
export function planClass(plan: string): string | undefined {
  switch (plan) {
    case 'free': return styles.planFree;
    case 'personal': return styles.planPersonal;
    case 'team': return styles.planTeam;
    case 'business': return styles.planBusiness;
    case 'enterprise': return styles.planEnterprise;
    default: return styles.planFree;
  }
}
